import { appRoute } from "src/app/app-route.constants";

/**
 * Internal forwarding routes or routes that must never be tracked via set_state or
 * restored (e.g. /init, /validate).
 */
export const excludedStateRoutes = [
  appRoute.init,
  appRoute.validate,
  appRoute.marketing,
];

/**
 * Routes that render without the app's layout(header, sidenav, footer) while embedded in myzPAX
 */
export const noLayoutRoutes = [
  appRoute.init,
  appRoute.validate,
  appRoute.marketing,
  appRoute.tile,
];

/**
 * Fallback routes (e.g. /marketing) are where SSO lands users who do NOT have access to Rehab Connect, so there should never be an active session here.
 * If a session exists, the user must not remain on the fallback route — redirect them into the app and let the existing guards/interceptor enforce validity.
 */
export const fallbackRoutes = [appRoute.marketing];

export const reactAppSegment = "rc";

const firstSegmentOf = (url: string): string => {
  const path = url.startsWith("/") ? url : `/${url}`;
  return path.split("?")[0].split("#")[0].split("/")[1] ?? "";
};

export const isReactAppRoute = (url: string): boolean =>
  firstSegmentOf(url) === reactAppSegment;

export const isExcludedStateRoute = (url: string): boolean =>
  excludedStateRoutes.includes(firstSegmentOf(url));

export const isNoLayoutRoute = (url: string): boolean =>
  noLayoutRoutes.includes(firstSegmentOf(url));

export const isFallbackRoute = (url: string): boolean =>
  fallbackRoutes.includes(firstSegmentOf(url));
